import {
	type PlacementMessageFrontendFactory,
	type AnyProps,
	type NoProps,
	type PlacementRenderer,
	type AnyFrontendStage,
	type PlacementBrowserConfig,
} from '@post-office/message-maker-browser/types';

import { createPlacementFrontend } from '@post-office/message-maker-browser/create-placement-frontend';

import Heading from '@atlaskit/heading/heading';

import { Inline } from '@atlaskit/primitives/inline';

import { Stack } from '@atlaskit/primitives/stack';

import { type EligibleMessage } from '@post-office/shared-contracts/shared-request-middleware-context';

import { usePlacementApi } from '@post-office/use-placement-api';

import { FormattedMessage } from 'react-intl';

import type { MessageTemplateContext } from './test-messages';

const placementConfig: PlacementBrowserConfig = {
	placementId: 'audio-player-spotlight-tour',
	options: {
		choreographer: {
			isDefaultEnabled: true,
		},
		hideInIsolatedCloud: false,
	},
};

const placement = {
	createFrontend: createPlacementFrontend(placementConfig),
};

export const createFrontend: <U extends AnyProps = NoProps>(
	placementRenderer: PlacementRenderer<
		{
			render: AnyFrontendStage;
		},
		U
	>,
) => PlacementMessageFrontendFactory<
	{
		render: AnyFrontendStage;
	},
	U
> = placement.createFrontend;

export const PlacementFrontend: PlacementMessageFrontendFactory<
	{
		render: AnyFrontendStage;
	},
	NoProps
> = createFrontend((Messages) => () => {
	const { data, error, isLoading } = usePlacementApi<{
		messages: Array<EligibleMessage<MessageTemplateContext>>;
	}>('/');

	if (error) {
		throw error;
	}

	return (
		<Stack space="space.150">
			<Heading as={'h1'} size="medium">
				<FormattedMessage
					id="post-office.audio-player-spotlight-tour.main-heading.no-translate"
					defaultMessage="Welcome to Placements v2"
					description="Example welcome message for Placements v2"
				/>
			</Heading>
			{!isLoading && (
				<Stack as="ul" space="space.200">
					{data.messages.map((props) => (
						<Inline as="li" key={props.messageInstanceId}>
							<Messages.render {...props} />
						</Inline>
					))}
				</Stack>
			)}
		</Stack>
	);
});
